exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.forIsrael{width:100vw;height:70vh;margin:0 auto;text-align:center;background:#fff;padding-top:30vh;font-size:4rem\n}\n", "", {"version":3,"sources":["C:/ProgramData/Jenkins/.jenkins/workspace/ICode_Dev_Client_HOME/src/components/forIsrael/C:/ProgramData/Jenkins/.jenkins/workspace/ICode_Dev_Client_HOME/src/components/forIsrael/index.vue"],"names":[],"mappings":";AA+CA,WACE,YACA,YACA,cACA,kBACA,gBACA,iBACA,cAAe;CAChB","file":"index.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\r\n.forIsrael {\r\n  width: 100vw;\r\n  height: 70vh;\r\n  margin: 0 auto;\r\n  text-align: center;\r\n  background: #fff;\r\n  padding-top: 30vh;\r\n  font-size: 4rem;\r\n}\r\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-27630e68","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/forIsrael/index.vue
// module id = 7Uiv
// module chunks = 1